import { Progress, Table, Tooltip, Typography } from "antd";
import { messageError, messageSuccess } from "../../../components/toastr";
import moment from "moment";
import styles from './linksTable.module.scss';

export const LinksTable = ({ links, loading, servicePlate, getLinks }) => {

    // const removeLink = (plateId) => {
    //     servicePlate
    //         .removeLink(plateId)
    //         .then(response => {
    //             if (response.data.status !== 200) {
    //                 messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
    //             } else {
    //                 messageSuccess("Vínculo excluído com sucesso!");
    //                 getLinks();
    //             }
    //         })
    //         .catch(erros => {
    //             if (erros.response.status === 404) {
    //                 messageError(erros.response.data.message);
    //             } else {
    //                 messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
    //             }
    //         })
    // };

    const columns = [
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '14px', fontWeight: 700 }}>Placa</div>
            },
            align: 'center',
            dataIndex: 'plate',
            key: 'plate',
            width: 80,
            filterSearch: true,
            render: (_, data) => {
                const plate = data.element.plate;
                return (
                    <Tooltip title="Placa">
                        <div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>
                            {plate}
                        </div>
                    </Tooltip>
                );
            }
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '14px', fontWeight: 700 }}>Rota</div>
            },
            align: 'center',
            dataIndex: 'name',
            key: 'name',
            width: 80,
            render: (_, data) => {
                const route = data.element.routeName;
                return (
                    <Tooltip title="Rota">
                        <div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>
                            {route}
                        </div>
                    </Tooltip>
                );
            }
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '14px', fontWeight: 700 }}>Vinculada em</div>
            },
            align: 'center',
            dataIndex: 'routeLoadDate',
            key: 'routeLoadDate',
            width: 100,
            render: (status, data) => {
                const dateTime = moment(data.element.routeLoadDate).format('DD/MM/YYYY, HH:mm:ss');
                const isDownloadFinished = (data.element.qtyPagesReceived / data.element.qtyPages) === 1;
                return (
                    isDownloadFinished ? (
                        <Tooltip title="Rota vinculada em">
                            <div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{dateTime}</div>
                        </Tooltip>
                    )
                        : (
                            <Tooltip title="Vinculação de rota em andamento.">
                                <div className={styles.textStyleWave}>PROCESSANDO</div>
                            </Tooltip>
                        )

                );
            }
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '14px', fontWeight: 700 }}>Status</div>
            },
            align: 'center',
            dataIndex: 'routeLoadStatus',
            key: 'routeLoadStatus',
            width: 200,
            render: (status, data) => {

                const percent = ((data.element.qtyPagesReceived / data.element.qtyPages) * 100).toFixed(
                    2
                );
                const dateNow = new Date();
                const dateStarted = new Date(data.element.startDate);
                const dateDiffInMs = Math.abs(dateNow - dateStarted);
                const formattedDiff = moment.utc(dateDiffInMs);

                const dateNowDays = moment();
                const dateStartedDays = moment(data.element.startDate);
                const daysDifference = dateNowDays.diff(dateStartedDays, "days");
                const isDownloadFinished = (data.element.qtyPagesReceived / data.element.qtyPages) === 1;
                return (
                    <>
                        {isDownloadFinished ?
                            <></>
                            :
                            daysDifference > 0 ?
                                <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-8px', fontWeight: 500, fontSize: '10px' }}>{`${daysDifference}dias - ${formattedDiff.hours()}h:${formattedDiff.minutes()}m:${formattedDiff.seconds()}s`}</Typography>
                                :
                                <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-8px', fontWeight: 500, fontSize: '10px' }}>{`${formattedDiff.hours()}h:${formattedDiff.minutes()}m:${formattedDiff.seconds()}s`}</Typography>
                        }
                        <Progress percent={percent} size="small" status={data.element.routeLoadStatus === "ERROR" ? "exception" : data.element.routeLoadStatus === "CONCLUDED" ? "success" : "active"} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-8px' }} />
                    </>
                );
            }
        },
    ];

    return (
        <Table style={{ marginTop: '35px', height: '100%', width: '100%' }} size={"small"} scroll={{ x: 'max-content' }} rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'} loading={loading} dataSource={links} columns={columns} pagination={false} />
    );
}